import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import axios from "axios";
import { Tx } from "../context/AutoTranslateContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WhatsAppOptIn = () => {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    axios.get(`${API}/whatsapp-optin`).then((r) => setCfg(r.data)).catch(() => {});
  }, []);

  if (!cfg?.url) return null;

  return (
    <div
      data-testid="whatsapp-optin"
      className="mt-8 rounded-3xl border-2 border-[#25D366]/40 bg-[#25D366]/10 p-6 text-left"
    >
      <h3 className="font-heading text-lg text-forest font-semibold mb-2">
        <Tx>Get your session reminders on WhatsApp</Tx>
      </h3>
      <p className="text-xs text-mute leading-relaxed mb-4">
        <Tx>
          To receive your booking confirmation and session reminders on WhatsApp,
          you need to opt in once. Tap the button below — it opens WhatsApp with a
          ready-made message. Just press send once, and you're connected.
        </Tx>
      </p>
      <a
        data-testid="whatsapp-optin-btn"
        href={cfg.url}
        target="_blank"
        rel="noreferrer"
        className="inline-flex items-center gap-2.5 bg-[#25D366] text-white hover:bg-[#20bd5a] rounded-full px-8 py-4 text-sm font-semibold transition-all hover:-translate-y-0.5 shadow-lg shadow-[#25D366]/30"
      >
        <MessageCircle className="w-5 h-5" />
        <Tx>Receive WhatsApp Reminders</Tx>
      </a>
    </div>
  );
};

export default WhatsAppOptIn;
